module.exports = __webpack_public_path__ + "static/media/020-orbit.98075ab3.svg";